export interface FilterOption {
  key: string;
  valueKey?: string; // Optional key to use for value (e.g. 'id' for dropdowns)
  label: string;
  optionsKey?: string; // Key in dropdownOptions from metadata
  staticOptions?: { value: string; label: string }[]; // Hardcoded options
}

export interface EntityFilterConfig {
  filters: FilterOption[];
}

export const entityFilterConfigs: Record<string, EntityFilterConfig | undefined> = {
  providers: {
    filters: [
      { key: 'site', label: 'Site', optionsKey: 'site_choices', valueKey: 'label' },
      { key: 'profession', label: 'Profession', optionsKey: 'profession_choices' }
    ],
  },
  // sites: undefined,  -- no filters
  // users: undefined,  -- no filters
};

